import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import CrmTeamUser from "./CrmTeamUser";
import GridConfig from "../GridConfig";

export default class CrmTeamUsers extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            crmTeamId: props.CrmTeamId,
            controllerName: 'crm/team/user',
            data: null,
            loading: true,
            configName: 'crmteamusers_grid',
            moduleName: 'کاربران تیم Crm'
        };
        this.state.filters = {
            crmTeamId: this.state.crmTeamId
        }
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.refreshData();
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({
            component: <CrmTeamUser Caller={this} Id={id} CrmTeamId={this.state.crmTeamId} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <CrmTeamUser Caller={this} CrmTeamId={this.state.crmTeamId} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "name", caption: "کاربر", show: true },
                { field: "createDate", caption: "تاریخ ثبت", show: true },
                { field: "editDate", caption: "تاریخ بروزرسانی", show: true }
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'name' && f.show) t.push({
                field: f.field, headerName: f.caption, flex: 3, cellRenderer: (props) => {
                    if (props.data.role === 1)
                        return <span className="text-primary txt-bold hand text-warning">{props.data.name}</span>
                    else
                        return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.name}</a>
                }
            });
            if (f.field == 'editDate' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'createDate' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        t.push({
            field: "", filter: false, flex: 2, headerName: "عملیات", cellRenderer: (props) => {
                return <ul className="flex flex-row">
                    <li>
                        <a className="btn btn-trigger btn-icon hand" onClick={e => this.confirmRemove(props.data.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف رکورد">
                            <em className="icon ni ni-cross-fill-c"></em>
                        </a>
                    </li>
                </ul>
            }
        });
        return t;
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "width": "96%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">کاربران تیم</h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                {this.getToolBar(false, { add: true, false: true, pdf: false, excell: false, remove: false, config: false, otherFilters: null })}
                                {this.renderAgGrid({
                                    columnDefs: this.getColumns()
                                })}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent()
            ];

        return contents;
    }
}